import FormsManagementPage from "../admin/forms-management/FormsManagementPage";

const FormUploaderPage = () => <FormsManagementPage restricted />;

export default FormUploaderPage;
